import moment from 'moment';

export const useIsSpecialOfferBannerActive = () => {
  return moment().isBetween(
    '2025-11-26T12:00:00+01:00',
    '2025-12-20T12:00:00+01:00',
  );
};

export const useIsSpecialOfferPageActive = () => {
  return false;
};

export const FLASH_OFFER_ANNON_URL =
  'https://www.bilendi-ux.com/end-of-year-sales';
export const FLASH_OFFER_URL = 'https://www.bilendi-ux.com/end-of-year-sales';
export const FLASH_OFFER_CALENDAR_LINK =
  'https://calendar.app.google/3Mgyrmmn17zHRgo77';
